import React from 'react';
import { useVehicles } from '@/hooks/useVehicles';

const AtithiAboutSection = () => {
  const { startingFare } = useVehicles({ activeOnly: true });

  const stats = [
    { number: '10,000+', label: 'Trips Completed' },
    { number: '100%', label: 'Verified Drivers' },
    { number: `₹${startingFare}/km`, label: 'Starting Fare' },
    { number: '24/7', label: 'Always Available' },
  ];

  return (
    <section className="about-outer section-standard bg-white">
      <div className="about-inner">
        <div className="about-image-col relative rounded-2xl overflow-hidden shadow-xl border border-gray-100 min-h-[280px]">
          <img
            src="/images/atithi-about-banner.png"
            alt="Atithi Travel & Taxi Service - Gujarat's No.1 Taxi Service"
            className="object-cover w-full h-full min-h-[280px]"
          />
          <div className="absolute inset-0 bg-[#0D1B3E]/20 rounded-2xl" />
        </div>

        <div className="about-text-col border-l-4 border-[#E8651A] pl-6">
          <p className="section-label">About Atithi</p>

          <h2 className="section-heading">Your Trusted Travel Partner Across Gujarat</h2>

          <div className="about-divider" />

          <p className="about-body">
            Atithi Travel &amp; Taxi Service is a trusted and customer-focused transportation company
            offering reliable travel solutions across Gujarat and beyond. We specialize in taxi services,
            airport transfers, outstation trips, local sightseeing, and corporate travel — with a fleet of
            well-maintained vehicles and experienced drivers.
          </p>

          <p className="about-body">
            Whether you need a quick city ride or a multi-day pilgrimage tour, we deliver safe, comfortable,
            and affordable travel — every time.
          </p>

          <div className="about-stats">
            {stats.map((s) => (
              <div key={s.label} className="about-stat">
                <span className="about-stat-number">{s.number}</span>
                <span className="about-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AtithiAboutSection;
